import HttpApis from "./HttpApis";
const REFRESH_CHECK_INTERVAL = 10000;

const Auth = {
  _intervalId: null,
  _isRefreshing: false,

  signOut() {
    Auth.stopAutoRefresh();
    localStorage.removeItem("authData");
  },

  isAuth() {
    return !!localStorage.getItem("authData");
  },

  setToken(data) {
    try {
      localStorage.setItem("authData", JSON.stringify(data));
    } catch (error) {
      console.error(error);
    }
  },

  getToken() {
    try {
      const string = localStorage.getItem("authData");
      if (!string) return null;
      return JSON.parse(string);
    } catch (error) {
      console.error(error);
      return null;
    }
  },

  clearStorage() {
    localStorage.clear();
  },

  isTokenExpired(expireDate) {
    if (!expireDate) return true;
    const expiryMs = expireDate * 1000;
    const now = Date.now();
    return now >= expiryMs;
  },

  isTokenExpiringSoon(expireDate) {
    if (!expireDate) return true;
    const expiryMs = expireDate * 1000;
    const now = Date.now();
    return expiryMs - now <= 60 * 60 * 1000;
  },

  // NEW: call this on app launch (same as splash screen logic)
  async checkOnAppLoad() {
    const auth = Auth.getToken();
    const token = auth?.token;
    const refreshToken = auth?.refresh_token;

    // No token and no refresh token — redirect to home
    if (!token && !refreshToken) {
      window.location.href = "/home";
      return;
    }

    // Has refresh token — try to refresh on launch
    if (refreshToken) {
      await Auth.tryRefresh();
    }

    // Start auto refresh
    Auth.startAutoRefresh();
  },

  async tryRefresh() {
    if (Auth._isRefreshing) return;

    const auth = Auth.getToken();
    if (!auth) return;

    const { refresh_token, expire_date } = auth;
    if (!refresh_token) return;

    const isExpired = Auth.isTokenExpired(expire_date);
    const isExpiringSoon = Auth.isTokenExpiringSoon(expire_date);

    if (!isExpired && !isExpiringSoon) return;

    Auth._isRefreshing = true;

    try {
      const res = await HttpApis.refreshToken(refresh_token);

      if (res?.data?.data) {
        const newData = {
          token: res.data.data.token,
          refresh_token: res.data.data.refresh_token,
          expire_date: res.data.data.expire_date,
        };
        Auth.setToken(newData);
      } else {
        console.error("Token refresh returned no data — logging out");
        Auth.clearStorage();
        Auth.stopAutoRefresh();
        window.location.href = "/home";
      }
    } catch (err) {
      console.error("Token refresh failed:", err);
      Auth.clearStorage();
      Auth.stopAutoRefresh();
      window.location.href = "/home";
    } finally {
      Auth._isRefreshing = false;
    }
  },

  async checkAndRefreshOnLoad() {
    await Auth.tryRefresh();
  },

  startAutoRefresh() {
    if (Auth._intervalId) {
      clearInterval(Auth._intervalId);
    }

    Auth._intervalId = setInterval(async () => {
      await Auth.tryRefresh();
    }, REFRESH_CHECK_INTERVAL);

    return Auth._intervalId;
  },

  stopAutoRefresh() {
    if (Auth._intervalId) {
      clearInterval(Auth._intervalId);
      Auth._intervalId = null;
    }
  },
};

export default Auth;